
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/check",
      function () {
        return require("private-next-pages/check/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/check"])
      });
    }
  